import { ReactComponent as IconSvg } from './icon_eye_hide.svg';
import Icon, { IconProps } from './icon';

const IconEyeHide = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconEyeHide;
